import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import React, { useEffect, useRef } from "react";

type DialogConfirmProps = {
  openDialog: boolean;
  handleConfirm?: () => void;
  handleClose: () => void;
  message: any;
  title: string;
  titleButtonOk: string;
  titleButtonNot?: string;
};
const DialogConfirm = ({
  openDialog,
  handleConfirm,
  handleClose,
  message,
  title,
  titleButtonOk,
  titleButtonNot,
}: DialogConfirmProps) => {
  const btnOk = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (btnOk.current) {
      btnOk.current.focus();
    }
  }, []);

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ display: "flex", flexDirection: "column" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {titleButtonNot ? (
          <Button onClick={handleClose} variant="outlined" color="primary">
            {titleButtonNot}
          </Button>
        ) : null}
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          autoFocus
          ref={btnOk}
        >
          {titleButtonOk}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirm;
